import React, { useContext, useEffect, useState } from 'react';
import { useProductContext } from './ProductContext';
import { fetchSocialProofData } from '../api/social-proof-messaging';
import { useExperiencesContext } from '../components/experiences/Experiences';

export const Context = React.createContext();

export const useSocialProofContext = () => useContext(Context);

export const Provider = ({ children }) => {
  const { products } = useProductContext();
  const { isSocialProofingProductCardOn } = useExperiencesContext();

  const [socialProofingMessages, setSocialProofingMessages] = useState({});
  const [previousProdIds, setPreviousProdIds] = useState([]);
  const [availableSocialProofMessages, setAvailableSocialProofMessages] =
    useState([]);

  const getSocialProofingDataPackage = () => {
    return products
      .map((product) => {
        if (previousProdIds.includes(product.id)) {
          return null;
        }

        return {
          productId: product.id,
          brand: product.brand,
          availableToOrder: !product.outOfStock,
        };
      })
      .filter((product) => product !== null);
  };

  const transformSocialProofingResponse = (newSocialProofingMessages) => {
    if (
      newSocialProofingMessages &&
      typeof newSocialProofingMessages === 'object'
    )
      return Object.values(newSocialProofingMessages).reduce((acc, value) => {
        acc[value.productId] = {
          id: value.productId,
          title: value.messages[0]?.title,
        };
        return acc;
      }, {});
  };

  useEffect(() => {
    setPreviousProdIds(products?.map((product) => product.id));
    setAvailableSocialProofMessages(getSocialProofingDataPackage());
  }, [products]);

  useEffect(() => {
    if (
      availableSocialProofMessages.length == 0 ||
      !isSocialProofingProductCardOn
    ) {
      return;
    }
    const fetchedData = async () => {
      try {
        const newSocialProofingMessages = await fetchSocialProofData(
          availableSocialProofMessages
        );
        const transformedMessages = transformSocialProofingResponse(
          newSocialProofingMessages
        );
        setSocialProofingMessages({
          ...socialProofingMessages,
          ...transformedMessages,
        });
        setPreviousProdIds(products?.map((product) => product.id));
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };
    fetchedData();
  }, [availableSocialProofMessages]);

  return (
    <Context.Provider value={socialProofingMessages}>
      {children}
    </Context.Provider>
  );
};
